/**
 @since: 2020-04-06
 @author: tams_dev1
 */
import resultFactory from '~/utils/resultFactory'
const dlpFilterData = () => {
  return {
    dlp_data_obj_id: 1, // (numeric)(not null)(range=1-40000) DLP 데이터 객체 / 그룹객체 ID
    dlp_excpt_prf_id: null, // (numeric)(range=1-31) DLP 예외 프로파일 ID
    dlp_filter_rule_uname: '', // (string)(not null)(range=0-32) DLP 프로파일 - 필터 이름
    dlp_filter_rule_use: 0, // (numeric)(range=0-1) DLP 프로파일 - 필터 사용(0:미사용, 1:사용)
    dlp_filter_rule_direct: 3, // (numeric)(range=1-3) DLP 프로파일 - 필터 방향(1:내부, 2:외부, 3:양방향)
    dlp_filter_rule_action: 0, // (numeric)(range=0-1) DLP 프로파일 - 필터 동작(0:탐지, 1:차단)
    dlp_filter_rule_log_use: 0, // (numeric)(range=0-1) DLP 프로파일 - 필터 로그(0:미사용, 1:사용)
    dlp_filter_rule_dump_use: 0, // (numeric)(range=0-1) DLP 프로파일 - 필터 덤프(0:미사용, 1:사용)
    dlp_filter_rule_mail_use: 0, // (numeric)(range=0-1) DLP 프로파일 - 필터 메일(0:미사용, 1:사용)
    dlp_filter_rule_desc: '', // (string)(range=0-128) DLP 프로파일 - 필터 설명
    smtp_use: 1, // (numeric)(range=0-1) SMTP 사용(0:미사용, 1:사용)
    pop3_use: 0, // (numeric)(range=0-1) POP3 사용(0:미사용, 1:사용)
    imap_use: 0, // (numeric)(range=0-1) IMAP 사용(0:미사용, 1:사용)
    http_use: 0, // (numeric)(range=0-1) HTTP 사용(0:미사용, 1:사용)
    ftp_use: 0, // (numeric)(range=0-1) FTP 사용(0:미사용, 1:사용)
    smtp_cmd: 0, // (numeric)(range=0-1) SMTP - 명령(0:미사용, 1:사용)
    smtp_rsps: 0, // (numeric)(range=0-1) SMTP - 응답(0:미사용, 1:사용)
    smtp_sndr: 0, // (numeric)(range=0-1) SMTP - 송신자(0:미사용, 1:사용)
    smtp_rcvr: 0, // (numeric)(range=0-1) SMTP - 수신자(0:미사용, 1:사용)
    smtp_sbjt: 0, // (numeric)(range=0-1) SMTP - 제목(0:미사용, 1:사용)
    smtp_header: 0, // (numeric)(range=0-1) SMTP - Header(0:미사용, 1:사용)
    smtp_body: 0, // (numeric)(range=0-1) SMTP - Body(0:미사용, 1:사용)
    smtp_fname: 0, // (numeric)(range=0-1) SMTP - 파일 이름(0:미사용, 1:사용)
    smtp_fbody: 0, // (numeric)(range=0-1) SMTP - 파일 내용(0:미사용, 1:사용)
    smtp_ftype: 0, // (numeric)(range=0-1) SMTP - 파일 유형(0:미사용, 1:사용)
    smtp_cntn_size: 0, // (numeric)(range=0-1) SMTP - Content 사이즈(0:미사용, 1:사용)
    smtp_attach_size: 0, // (numeric)(range=0-1) SMTP - Attachment 사이즈(0:미사용, 1:사용)
    pop3_sndr: 0, // (numeric)(range=0-1) POP3 - 송신자(0:미사용, 1:사용)
    pop3_rcvr: 0, // (numeric)(range=0-1) POP3 - 수신자(0:미사용, 1:사용)
    pop3_sbjt: 0, // (numeric)(range=0-1) POP3 - 제목(0:미사용, 1:사용)
    pop3_header: 0, // (numeric)(range=0-1) POP3 - Header(0:미사용, 1:사용)
    pop3_body: 0, // (numeric)(range=0-1) POP3 - Body(0:미사용, 1:사용)
    pop3_fname: 0, // (numeric)(range=0-1) POP3 - 파일 이름(0:미사용, 1:사용)
    pop3_fbody: 0, // (numeric)(range=0-1) POP3 - 파일 내용(0:미사용, 1:사용)
    pop3_ftype: 0, // (numeric)(range=0-1) POP3 - 파일 유형(0:미사용, 1:사용)
    pop3_cntn_size: 0, // (numeric)(range=0-1) POP3 - Content 사이즈(0:미사용, 1:사용)
    pop3_attach_size: 0, // (numeric)(range=0-1) POP3 - Attachment 사이즈(0:미사용, 1:사용)
    imap_sndr: 0, // (numeric)(range=0-1) IMAP - 송신자(0:미사용, 1:사용)
    imap_rcvr: 0, // (numeric)(range=0-1) IMAP - 수신자(0:미사용, 1:사용)
    imap_sbjt: 0, // (numeric)(range=0-1) IMAP - 제목(0:미사용, 1:사용)
    imap_header: 0, // (numeric)(range=0-1) IMAP - Header(0:미사용, 1:사용)
    imap_body: 0, // (numeric)(range=0-1) IMAP - Body(0:미사용, 1:사용)
    imap_fname: 0, // (numeric)(range=0-1) IMAP - 파일 이름(0:미사용, 1:사용)
    imap_fbody: 0, // (numeric)(range=0-1) IMAP - 파일 내용(0:미사용, 1:사용)
    imap_ftype: 0, // (numeric)(range=0-1) IMAP - 파일 유형(0:미사용, 1:사용)
    imap_cntn_size: 0, // (numeric)(range=0-1) IMAP - Content 사이즈(0:미사용, 1:사용)
    imap_attach_size: 0, // (numeric)(range=0-1) IMAP - Attachment 사이즈(0:미사용, 1:사용)
    http_rqst_method: 0, // (numeric)(range=0-1) HTTP 요청 - Method(0:미사용, 1:사용)
    http_rqst_url: 0, // (numeric)(range=0-1) HTTP 요청 - URL(0:미사용, 1:사용)
    http_rqst_url_raw: 0, // (numeric)(range=0-1) HTTP 요청 - URL Raw(0:미사용, 1:사용)
    http_rqst_host: 0, // (numeric)(range=0-1) HTTP 요청 - Host(0:미사용, 1:사용)
    http_rqst_start_line: 0, // (numeric)(range=0-1) HTTP 요청 - Start Line(0:미사용, 1:사용)
    http_rqst_header: 0, // (numeric)(range=0-1) HTTP 요청 - Header(0:미사용, 1:사용)
    http_rqst_header_raw: 0, // (numeric)(range=0-1) HTTP 요청 - Header Raw(0:미사용, 1:사용)
    http_rqst_body: 0, // (numeric)(range=0-1) HTTP 요청 - Body(0:미사용, 1:사용)
    http_rqst_body_raw: 0, // (numeric)(range=0-1) HTTP 요청 - Body Raw(0:미사용, 1:사용)
    http_rqst_fname: 0, // (numeric)(range=0-1) HTTP 요청 - 파일 이름(0:미사용, 1:사용)
    http_rqst_fbody: 0, // (numeric)(range=0-1) HTTP 요청 - 파일 내용(0:미사용, 1:사용)
    http_rqst_ftype: 0, // (numeric)(range=0-1) HTTP 요청 - 파일 유형(0:미사용, 1:사용)
    http_rqst_cntn_size: 0, // (numeric)(range=0-1) HTTP 요청 - Content 사이즈(0:미사용, 1:사용)
    http_rqst_file_size: 0, // (numeric)(range=0-1) HTTP 요청 - 파일 사이즈(0:미사용, 1:사용)
    http_rsps_start_line: 0, // (numeric)(range=0-1) HTTP 응답 - Start Line(0:미사용, 1:사용)
    http_rsps_header: 0, // (numeric)(range=0-1) HTTP 응답 - Header(0:미사용, 1:사용)
    http_rsps_header_raw: 0, // (numeric)(range=0-1) HTTP 응답 - Header Raw(0:미사용, 1:사용)
    http_rsps_body: 0, // (numeric)(range=0-1) HTTP 응답 - Body(0:미사용, 1:사용)
    http_rsps_body_raw: 0, // (numeric)(range=0-1) HTTP 응답 - Body Raw(0:미사용, 1:사용)
    http_rsps_fname: 0, // (numeric)(range=0-1) HTTP 응답 - 파일 이름(0:미사용, 1:사용)
    http_rsps_fbody: 0, // (numeric)(range=0-1) HTTP 응답 - 파일 내용(0:미사용, 1:사용)
    http_rsps_ftype: 0, // (numeric)(range=0-1) HTTP 응답 - 파일 유형(0:미사용, 1:사용)
    http_rsps_cntn_size: 0, // (numeric)(range=0-1) HTTP 응답 - Content 사이(0:미사용, 1:사용)
    http_rsps_file_size: 0, // (numeric)(range=0-1) HTTP 응답 - 파일 사이즈(0:미사용, 1:사용)
    ftp_rqst_cmd: 0, // (numeric)(range=0-1) FTP 요청 - 명령(0:미사용, 1:사용)
    ftp_rqst_fname: 0, // (numeric)(range=0-1) FTP 요철 - 파일 이름(0:미사용, 1:사용)
    ftp_rqst_fbody: 0, // (numeric)(range=0-1) FTP 요청 - 파일 내용(0:미사용, 1:사용)
    ftp_rqst_ftype: 0, // (numeric)(range=0-1) FTP 요청 - 파일 유형(0:미사용, 1:사용)
    ftp_rqst_file_size: 0, // (numeric)(range=0-1) FTP 요청 - 파일 사이즈(0:미사용, 1:사용)
    ftp_rsps_rsps: 0, // (numeric)(range=0-1) FTP 응답 - 응답(0:미사용, 1:사용)
    ftp_rsps_fname: 0, // (numeric)(range=0-1) FTP 응답 - 파일 이름(0:미사용, 1:사용)
    ftp_rsps_fbody: 0, // (numeric)(range=0-1) FTP 응답 - 파일 내용(0:미사용, 1:사용)
    ftp_rsps_ftype: 0, // (numeric)(range=0-1) FTP 응답 - 파일 유형(0:미사용, 1:사용)
    ftp_rsps_file_size: 0, // (numeric)(range=0-1) FTP 응답 - 파일 사이즈(0:미사용, 1:사용)
    dlp_prf_id: null, // (numeric)(not null)(range=1-31) DLP 프로파일 ID',
    dlp_filter_rule_id: null // (numeric)(not null)(range=1-1000) DLP 프로파일 - 필터ID
  }
}
const dlpArchiveData = () => {
  return {
    dlp_data_obj_id: null, // (numeric)(range=1-20000) DLP 데이터 객체 ID,
    dlp_excpt_prf_id: null, // (numeric)(range=1-31) DLP 예외 프로파일 ID,
    dlp_arch_rule_uname: '', // (string)(range=0-32) DLP 프로파일 - 아카이브 이름,
    dlp_arch_rule_use: 0, // (numeric)(range=0-1) DLP 프로파일 - 아카이브 사용(0:미사용, 1:사용),
    dlp_arch_rule_direct: 3, // (numeric)(range=1-3) DLP 프로파일 - 아카이브 방향(1:내부, 2:외부, 3:양방향),
    dlp_arch_rule_action: 3, // (numeric) DLP 프로파일 - 아카이브 동작(3:Archive),
    dlp_arch_rule_log_use: 0, // (numeric)(range=0-1) DLP 프로파일 - 아카이브 로그(0:미사용, 1:사용),
    dlp_arch_rule_desc: '', // (string)(range=0-128) DLP 프로파일 - 아카이브 설명,
    smtp_use: 1, // (numeric)(range=0-1) SMTP 사용(0:미사용, 1:사용),
    pop3_use: 0, // (numeric)(range=0-1) POP3 사용(0:미사용, 1:사용),
    imap_use: 0, // (numeric)(range=0-1) IMAP 사용(0:미사용, 1:사용),
    http_use: 0, // (numeric)(range=0-1) HTTP 사용(0:미사용, 1:사용),
    ftp_use: 0, // (numeric)(range=0-1) FTP 사용(0:미사용, 1:사용),
    smtp_attach: 0, // (numeric)(range=0-1) SMTP - Attachment,
    smtp_header: 0, // (numeric)(range=0-1) SMTP - Header,
    smtp_body: 0, // (numeric)(range=0-1) SMTP - Body,
    pop3_attach: 0, // (numeric)(range=0-1) POP3 - Attachment,
    pop3_header: 0, // (numeric)(range=0-1) POP3 - Header,
    pop3_body: 0, // (numeric)(range=0-1) POP3 - Body,
    imap_attach: 0, // (numeric)(range=0-1) IMAP - Attachment,
    imap_header: 0, // (numeric)(range=0-1) IMAP - Header,
    imap_body: 0, // (numeric)(range=0-1) IMAP - Body,
    http_rqst_header: 0, // (numeric)(range=0-1) HTTP 요청 - Header,
    http_rqst_file: 0, // (numeric)(range=0-1) HTTP 요청 - 파일,
    http_rqst_body: 0, // (numeric)(range=0-1) HTTP 요철 - Body,
    http_rsps_header: 0, // (numeric)(range=0-1) HTTP 응답 - Header,
    http_rsps_file: 0, // (numeric)(range=0-1) HTTP 응답 - 파일,
    http_rsps_body: 0, // (numeric)(range=0-1) HTTP 응답 - Body,
    ftp_rqst_file: 0, // (numeric)(range=0-1) FTP 요청 - 명령,
    ftp_rqst_cmd: 0, // (numeric)(range=0-1) FTP 요청 - 파일,
    ftp_rsps_file: 0, // (numeric)(range=0-1) FTP 응답 - 파일,
    ftp_rsps_cmd: 0, // (numeric)(range=0-1) FTP 응답 - 응답,
    dlp_prf_id: null, // (numeric)(not null)(range=1-31) DLP 프로파일 ID,
    dlp_arch_rule_id: null // (numeric)(not null)(range=3001-4000) DLP 프로파일 - 아카이브ID
  }
}
export const state = () => ({
  txtDlpProtocolUrl: '/api/op/dlp/protocols',
  txtDlpProfileUrl: '/api/op/dlp/profiles',
  txtDlpExpProfileUrl: '/api/op/dlp/exceptions',
  getDlpProtocolData: [],
  getDlpProfileData: [],
  getExpProfileData: [],
  rowSelectItems: {},
  filterRuleSelectItems: {},
  getDlpFilterData: [],
  modifyDlpFilterData: dlpFilterData(),
  archiveRuleSelectItems: {},
  getDlpArchiveData: [],
  modifyDlpArchiveData: dlpArchiveData()
})

const modifyExpProfileData = (source) => {
  const target = []
  if (source.length > 0) {
    target.push({
      label: '',
      value: null
    })
  }
  for (const key of source) {
    target.push({
      label: key.dlp_excpt_prf_uname,
      value: key.dlp_excpt_prf_id
    })
  }
  return target
}
const getProtocolName = (item) => {
  let txtTemp = ''
  if (item.smtp_use === 1) {
    txtTemp += 'SMTP,'
  }
  if (item.pop3_use === 1) {
    txtTemp += 'POP3,'
  }
  if (item.imap_use === 1) {
    txtTemp += 'IMAP,'
  }
  if (item.http_use === 1) {
    txtTemp += 'HTTP,'
  }
  if (item.ftp_use === 1) {
    txtTemp += 'FTP,'
  }
  return txtTemp.slice(0, -1)
}

export const mutations = {
  clearStore: (state) => {
    state.getDlpProtocolData = []
    state.getDlpProfileData = []
    state.getExpProfileData = []
    state.rowSelectItems = {} // 프로파일 선택
    state.filterRuleSelectItems = {} // 필터 정책 선택
    state.getDlpFilterData = []
    state.modifyDlpFilterData = []
    state.archiveRuleSelectItems = {}
    state.getDlpArchiveData = []
    state.modifyDlpArchiveData = {}
  },
  getDlpProtocolDataAction: (state, data) => {
    state.getDlpProtocolData = _.cloneDeep(data)
  },
  setRowSelectItems: (state, data) => {
    state.rowSelectItems = _.cloneDeep(data)
  },
  setFilterRuleSelectItems: (state, data) => {
    state.filterRuleSelectItems = _.cloneDeep(data)
  },
  setArchiveRuleSelectItems: (state, data) => {
    state.archiveRuleSelectItems = _.cloneDeep(data)
  },
  setFilterPopupData: (state, data) => {
    state.modifyDlpFilterData = _.cloneDeep(data)
  },
  setArchivePopupData: (state, data) => {
    state.modifyDlpArchiveData = _.cloneDeep(data)
  },
  getDlpProfileDataAction: (state, data) => {
    state.getDlpProfileData = _.cloneDeep(data)
  },
  getExpProfileDataAction: (state, data) => {
    state.getExpProfileData = _.cloneDeep(modifyExpProfileData(data))
  },
  addDlpProfileDataAction: (state, data) => {
    state.getDlpProfileData.push(data)
  },
  editDlpProfileDataAction: (state, data) => {
    state.getDlpProfileData = _.map(state.getDlpProfileData, (item) => {
      if (item.dlp_prf_id === data.dlp_prf_id) {
        item = _.cloneDeep(data)
      }
      return item
    })
  },
  profileHeaderMutation: (state, data) => {
    state.getDlpProfileData = _.map(state.getDlpProfileData, (item) => {
      item.dlp_prf_use = data
      return item
    })
  },
  filterHeaderMutation: (state, data) => {
    if (data.length > 0) {
      var temp = _.omit(data[0], 'dlp_filter_rule_id')
      const key = _.keys(temp)[0]
      const val = data[0][key]
      state.getDlpFilterData = _.map(state.getDlpFilterData, (item) => {
        item[key] = val
        return item
      })
    }
  },
  archiveHeaderMutation: (state, data) => {
    if (data.length > 0) {
      var temp = _.omit(data[0], 'dlp_arch_rule_id')
      const key = _.keys(temp)[0]
      const val = data[0][key]
      state.getDlpArchiveData = _.map(state.getDlpArchiveData, (item) => {
        item[key] = val
        return item
      })
    }
  },
  clearGetDlpFilterData: (state) => {
    state.getDlpFilterData = []
  },
  getDlpFilterDataAction: (state, data) => {
    state.getDlpFilterData = _.map(data, (item) => {
      item.protocolName = getProtocolName(item)
      return item
    })
  },
  initFilterPopupData: (state) => { //  // 필터 데이터 초기화
    state.modifyDlpFilterData = {
      dlp_data_obj_id: 1, // (numeric)(not null)(range=1-40000) DLP 데이터 객체 / 그룹객체 ID
      dlp_excpt_prf_id: null, // (numeric)(range=1-31) DLP 예외 프로파일 ID
      dlp_filter_rule_uname: '', // (string)(not null)(range=0-32) DLP 프로파일 - 필터 이름
      dlp_filter_rule_use: 0, // (numeric)(range=0-1) DLP 프로파일 - 필터 사용(0:미사용, 1:사용)
      dlp_filter_rule_direct: 3, // (numeric)(range=1-3) DLP 프로파일 - 필터 방향(1:내부, 2:외부, 3:양방향)
      dlp_filter_rule_action: 0, // (numeric)(range=0-1) DLP 프로파일 - 필터 동작(0:탐지, 1:차단)
      dlp_filter_rule_log_use: 0, // (numeric)(range=0-1) DLP 프로파일 - 필터 로그(0:미사용, 1:사용)
      dlp_filter_rule_dump_use: 0, // (numeric)(range=0-1) DLP 프로파일 - 필터 덤프(0:미사용, 1:사용)
      dlp_filter_rule_mail_use: 0, // (numeric)(range=0-1) DLP 프로파일 - 필터 메일(0:미사용, 1:사용)
      dlp_filter_rule_desc: '', // (string)(range=0-128) DLP 프로파일 - 필터 설명
      smtp_use: 1, // (numeric)(range=0-1) SMTP 사용(0:미사용, 1:사용)
      pop3_use: 0, // (numeric)(range=0-1) POP3 사용(0:미사용, 1:사용)
      imap_use: 0, // (numeric)(range=0-1) IMAP 사용(0:미사용, 1:사용)
      http_use: 0, // (numeric)(range=0-1) HTTP 사용(0:미사용, 1:사용)
      ftp_use: 0, // (numeric)(range=0-1) FTP 사용(0:미사용, 1:사용)
      smtp_cmd: 0, // (numeric)(range=0-1) SMTP - 명령(0:미사용, 1:사용)
      smtp_rsps: 0, // (numeric)(range=0-1) SMTP - 응답(0:미사용, 1:사용)
      smtp_sndr: 0, // (numeric)(range=0-1) SMTP - 송신자(0:미사용, 1:사용)
      smtp_rcvr: 0, // (numeric)(range=0-1) SMTP - 수신자(0:미사용, 1:사용)
      smtp_sbjt: 0, // (numeric)(range=0-1) SMTP - 제목(0:미사용, 1:사용)
      smtp_header: 0, // (numeric)(range=0-1) SMTP - Header(0:미사용, 1:사용)
      smtp_body: 0, // (numeric)(range=0-1) SMTP - Body(0:미사용, 1:사용)
      smtp_fname: 0, // (numeric)(range=0-1) SMTP - 파일 이름(0:미사용, 1:사용)
      smtp_fbody: 0, // (numeric)(range=0-1) SMTP - 파일 내용(0:미사용, 1:사용)
      smtp_ftype: 0, // (numeric)(range=0-1) SMTP - 파일 유형(0:미사용, 1:사용)
      smtp_cntn_size: 0, // (numeric)(range=0-1) SMTP - Content 사이즈(0:미사용, 1:사용)
      smtp_attach_size: 0, // (numeric)(range=0-1) SMTP - Attachment 사이즈(0:미사용, 1:사용)
      pop3_sndr: 0, // (numeric)(range=0-1) POP3 - 송신자(0:미사용, 1:사용)
      pop3_rcvr: 0, // (numeric)(range=0-1) POP3 - 수신자(0:미사용, 1:사용)
      pop3_sbjt: 0, // (numeric)(range=0-1) POP3 - 제목(0:미사용, 1:사용)
      pop3_header: 0, // (numeric)(range=0-1) POP3 - Header(0:미사용, 1:사용)
      pop3_body: 0, // (numeric)(range=0-1) POP3 - Body(0:미사용, 1:사용)
      pop3_fname: 0, // (numeric)(range=0-1) POP3 - 파일 이름(0:미사용, 1:사용)
      pop3_fbody: 0, // (numeric)(range=0-1) POP3 - 파일 내용(0:미사용, 1:사용)
      pop3_ftype: 0, // (numeric)(range=0-1) POP3 - 파일 유형(0:미사용, 1:사용)
      pop3_cntn_size: 0, // (numeric)(range=0-1) POP3 - Content 사이즈(0:미사용, 1:사용)
      pop3_attach_size: 0, // (numeric)(range=0-1) POP3 - Attachment 사이즈(0:미사용, 1:사용)
      imap_sndr: 0, // (numeric)(range=0-1) IMAP - 송신자(0:미사용, 1:사용)
      imap_rcvr: 0, // (numeric)(range=0-1) IMAP - 수신자(0:미사용, 1:사용)
      imap_sbjt: 0, // (numeric)(range=0-1) IMAP - 제목(0:미사용, 1:사용)
      imap_header: 0, // (numeric)(range=0-1) IMAP - Header(0:미사용, 1:사용)
      imap_body: 0, // (numeric)(range=0-1) IMAP - Body(0:미사용, 1:사용)
      imap_fname: 0, // (numeric)(range=0-1) IMAP - 파일 이름(0:미사용, 1:사용)
      imap_fbody: 0, // (numeric)(range=0-1) IMAP - 파일 내용(0:미사용, 1:사용)
      imap_ftype: 0, // (numeric)(range=0-1) IMAP - 파일 유형(0:미사용, 1:사용)
      imap_cntn_size: 0, // (numeric)(range=0-1) IMAP - Content 사이즈(0:미사용, 1:사용)
      imap_attach_size: 0, // (numeric)(range=0-1) IMAP - Attachment 사이즈(0:미사용, 1:사용)
      http_rqst_method: 0, // (numeric)(range=0-1) HTTP 요청 - Method(0:미사용, 1:사용)
      http_rqst_url: 0, // (numeric)(range=0-1) HTTP 요청 - URL(0:미사용, 1:사용)
      http_rqst_url_raw: 0, // (numeric)(range=0-1) HTTP 요청 - URL Raw(0:미사용, 1:사용)
      http_rqst_host: 0, // (numeric)(range=0-1) HTTP 요청 - Host(0:미사용, 1:사용)
      http_rqst_start_line: 0, // (numeric)(range=0-1) HTTP 요청 - Start Line(0:미사용, 1:사용)
      http_rqst_header: 0, // (numeric)(range=0-1) HTTP 요청 - Header(0:미사용, 1:사용)
      http_rqst_header_raw: 0, // (numeric)(range=0-1) HTTP 요청 - Header Raw(0:미사용, 1:사용)
      http_rqst_body: 0, // (numeric)(range=0-1) HTTP 요청 - Body(0:미사용, 1:사용)
      http_rqst_body_raw: 0, // (numeric)(range=0-1) HTTP 요청 - Body Raw(0:미사용, 1:사용)
      http_rqst_fname: 0, // (numeric)(range=0-1) HTTP 요청 - 파일 이름(0:미사용, 1:사용)
      http_rqst_fbody: 0, // (numeric)(range=0-1) HTTP 요청 - 파일 내용(0:미사용, 1:사용)
      http_rqst_ftype: 0, // (numeric)(range=0-1) HTTP 요청 - 파일 유형(0:미사용, 1:사용)
      http_rqst_cntn_size: 0, // (numeric)(range=0-1) HTTP 요청 - Content 사이즈(0:미사용, 1:사용)
      http_rqst_file_size: 0, // (numeric)(range=0-1) HTTP 요청 - 파일 사이즈(0:미사용, 1:사용)
      http_rsps_start_line: 0, // (numeric)(range=0-1) HTTP 응답 - Start Line(0:미사용, 1:사용)
      http_rsps_header: 0, // (numeric)(range=0-1) HTTP 응답 - Header(0:미사용, 1:사용)
      http_rsps_header_raw: 0, // (numeric)(range=0-1) HTTP 응답 - Header Raw(0:미사용, 1:사용)
      http_rsps_body: 0, // (numeric)(range=0-1) HTTP 응답 - Body(0:미사용, 1:사용)
      http_rsps_body_raw: 0, // (numeric)(range=0-1) HTTP 응답 - Body Raw(0:미사용, 1:사용)
      http_rsps_fname: 0, // (numeric)(range=0-1) HTTP 응답 - 파일 이름(0:미사용, 1:사용)
      http_rsps_fbody: 0, // (numeric)(range=0-1) HTTP 응답 - 파일 내용(0:미사용, 1:사용)
      http_rsps_ftype: 0, // (numeric)(range=0-1) HTTP 응답 - 파일 유형(0:미사용, 1:사용)
      http_rsps_cntn_size: 0, // (numeric)(range=0-1) HTTP 응답 - Content 사이(0:미사용, 1:사용)
      http_rsps_file_size: 0, // (numeric)(range=0-1) HTTP 응답 - 파일 사이즈(0:미사용, 1:사용)
      ftp_rqst_cmd: 0, // (numeric)(range=0-1) FTP 요청 - 명령(0:미사용, 1:사용)
      ftp_rqst_fname: 0, // (numeric)(range=0-1) FTP 요철 - 파일 이름(0:미사용, 1:사용)
      ftp_rqst_fbody: 0, // (numeric)(range=0-1) FTP 요청 - 파일 내용(0:미사용, 1:사용)
      ftp_rqst_ftype: 0, // (numeric)(range=0-1) FTP 요청 - 파일 유형(0:미사용, 1:사용)
      ftp_rqst_file_size: 0, // (numeric)(range=0-1) FTP 요청 - 파일 사이즈(0:미사용, 1:사용)
      ftp_rsps_rsps: 0, // (numeric)(range=0-1) FTP 응답 - 응답(0:미사용, 1:사용)
      ftp_rsps_fname: 0, // (numeric)(range=0-1) FTP 응답 - 파일 이름(0:미사용, 1:사용)
      ftp_rsps_fbody: 0, // (numeric)(range=0-1) FTP 응답 - 파일 내용(0:미사용, 1:사용)
      ftp_rsps_ftype: 0, // (numeric)(range=0-1) FTP 응답 - 파일 유형(0:미사용, 1:사용)
      ftp_rsps_file_size: 0, // (numeric)(range=0-1) FTP 응답 - 파일 사이즈(0:미사용, 1:사용)
      dlp_prf_id: state.rowSelectItems[0].dlp_prf_id, // (numeric)(not null)(range=1-31) DLP 프로파일 ID',
      dlp_filter_rule_id: null // (numeric)(not null)(range=1-1000) DLP 프로파일 - 필터ID
    }
  },
  initArchivePopupData: (state) => { // 아카이브 데이터 초기화
    state.modifyDlpArchiveData = {
      dlp_data_obj_id: null, // (numeric)(range=1-20000) DLP 데이터 객체 ID,
      dlp_excpt_prf_id: null, // (numeric)(range=1-31) DLP 예외 프로파일 ID,
      dlp_arch_rule_uname: '', // (string)(range=0-32) DLP 프로파일 - 아카이브 이름,
      dlp_arch_rule_use: 0, // (numeric)(range=0-1) DLP 프로파일 - 아카이브 사용(0:미사용, 1:사용),
      dlp_arch_rule_direct: 3, // (numeric)(range=1-3) DLP 프로파일 - 아카이브 방향(1:내부, 2:외부, 3:양방향),
      dlp_arch_rule_action: 3, // (numeric) DLP 프로파일 - 아카이브 동작(3:Archive),
      dlp_arch_rule_log_use: 0, // (numeric)(range=0-1) DLP 프로파일 - 아카이브 로그(0:미사용, 1:사용),
      dlp_arch_rule_desc: '', // (string)(range=0-128) DLP 프로파일 - 아카이브 설명,
      smtp_use: 1, // (numeric)(range=0-1) SMTP 사용(0:미사용, 1:사용),
      pop3_use: 0, // (numeric)(range=0-1) POP3 사용(0:미사용, 1:사용),
      imap_use: 0, // (numeric)(range=0-1) IMAP 사용(0:미사용, 1:사용),
      http_use: 0, // (numeric)(range=0-1) HTTP 사용(0:미사용, 1:사용),
      ftp_use: 0, // (numeric)(range=0-1) FTP 사용(0:미사용, 1:사용),
      smtp_attach: 0, // (numeric)(range=0-1) SMTP - Attachment,
      smtp_header: 0, // (numeric)(range=0-1) SMTP - Header,
      smtp_body: 0, // (numeric)(range=0-1) SMTP - Body,
      pop3_attach: 0, // (numeric)(range=0-1) POP3 - Attachment,
      pop3_header: 0, // (numeric)(range=0-1) POP3 - Header,
      pop3_body: 0, // (numeric)(range=0-1) POP3 - Body,
      imap_attach: 0, // (numeric)(range=0-1) IMAP - Attachment,
      imap_header: 0, // (numeric)(range=0-1) IMAP - Header,
      imap_body: 0, // (numeric)(range=0-1) IMAP - Body,
      http_rqst_header: 0, // (numeric)(range=0-1) HTTP 요청 - Header,
      http_rqst_file: 0, // (numeric)(range=0-1) HTTP 요청 - 파일,
      http_rqst_body: 0, // (numeric)(range=0-1) HTTP 요철 - Body,
      http_rsps_header: 0, // (numeric)(range=0-1) HTTP 응답 - Header,
      http_rsps_file: 0, // (numeric)(range=0-1) HTTP 응답 - 파일,
      http_rsps_body: 0, // (numeric)(range=0-1) HTTP 응답 - Body,
      ftp_rqst_file: 0, // (numeric)(range=0-1) FTP 요청 - 명령,
      ftp_rqst_cmd: 0, // (numeric)(range=0-1) FTP 요청 - 파일,
      ftp_rsps_file: 0, // (numeric)(range=0-1) FTP 응답 - 파일,
      ftp_rsps_cmd: 0, // (numeric)(range=0-1) FTP 응답 - 응답,
      dlp_prf_id: state.rowSelectItems[0].dlp_prf_id, // (numeric)(not null)(range=1-31) DLP 프로파일 ID,
      dlp_arch_rule_id: null // (numeric)(not null)(range=3001-4000) DLP 프로파일 - 아카이브ID
    }
  },
  addDlpFilterDataAction: (state, data) => {
    data.protocolName = _.cloneDeep(getProtocolName(data))
    state.getDlpFilterData.push(data)
  },
  editDlpFilterDataAction: (state, data) => {
    state.getDlpFilterData = _.map(state.getDlpFilterData, (item) => {
      if (item.dlp_filter_rule_id === data.dlp_filter_rule_id) {
        item = _.cloneDeep(data)
        item.protocolName = getProtocolName(item)
      }
      return item
    })
  },
  clearGetDlpArchiveData: (state) => {
    state.getDlpArchiveData = []
  },
  getDlpArchiveDataAction: (state, data) => {
    // 전체 조회는 데이터 초기화 추가/수정인 경우는 초기화 하지 않는다.
    state.getDlpArchiveData = _.map(data, (item) => {
      item.protocolName = getProtocolName(item)
      return item
    })
  },
  addDlpArchiveDataAction: (state, data) => {
    data.protocolName = _.cloneDeep(getProtocolName(data))
    state.getDlpArchiveData.push(data)
  },
  editDlpArchiveDataAction: (state, data) => {
    state.getDlpArchiveData = _.map(state.getDlpArchiveData, (item) => {
      if (item.dlp_arch_rule_id === data.dlp_arch_rule_id) {
        item = _.cloneDeep(data)
        item.protocolName = getProtocolName(item)
      }
      return item
    })
  }
}

export const actions = {
  // DLP 프로토콜 조회
  async getDlpProtocolDataAction ({commit, state}) {
    try {
      const data = await this.$axios.$get(state.txtDlpProtocolUrl)
      return resultFactory(commit, {length: null, data: data, action: 'getDlpProtocolDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // DLP 프로파일 조회
  async getDlpProfileDataAction ({commit, state}) {
    try {
      const data = await this.$axios.$get(state.txtDlpProfileUrl)
      return resultFactory(commit, {length: null, data: data, action: 'getDlpProfileDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // DLP 예외 프로파일 조회
  async getExpProfileDataAction ({commit, state}) {
    try {
      const data = await this.$axios.$get(state.txtDlpExpProfileUrl)
      return resultFactory(commit, {length: null, data: data, action: 'getExpProfileDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // DLP 프로파일 추가 (error 처리 완료)
  async addDlpProfileDataAction ({commit, state, dispatch}, payload) {
    try {
      const data = await this.$axios.$post(state.txtDlpProfileUrl, payload)
      return resultFactory(commit, {length: null, data: data, action: 'addDlpProfileDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // DLP 프로파일 수정 (error 처리 완료)
  async editDlpProfileDataAction ({commit, state, dispatch}, payload) {
    try {
      const data = await this.$axios.$put(`${state.txtDlpProfileUrl}/${state.rowSelectItems[0].dlp_prf_id}`, payload)
      return resultFactory(commit, {length: null, data: data, action: 'editDlpProfileDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // DLP 프로파일 일괄수정 (error 처리 완료)
  async editDlpProfileListDataAction ({commit, state, dispatch}, payload) {
    try {
      const data = await this.$axios.$put(state.txtDlpProfileUrl, {items: payload}, {failAlert: false})
      return resultFactory(commit, {length: payload.length, data: data, action: null, param: 'edit'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // DLP 프로파일 삭제
  async delDlpProfileDataAction ({commit, state}) {
    let isMulty = false
    const idList = []
    if (state.rowSelectItems.length > 1) {
      isMulty = true
      state.rowSelectItems.forEach((item) => {
        idList.push({'dlp_prf_id': item.dlp_prf_id})
      })
    }
    try {
      const data = isMulty ? await this.$axios.$delete(state.txtDlpProfileUrl, {data: {items: idList}}, {failAlert: false})
        : await this.$axios.$delete(`${state.txtDlpProfileUrl}/${state.rowSelectItems[0].dlp_prf_id}`)
      return resultFactory(commit, {length: idList.length, data: data, action: null, param: 'delete'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // DLP 필터 데이터 조회
  async getDlpFilterDataAction ({commit, state}) {
    try {
      const data = await this.$axios.$get(`${state.txtDlpProfileUrl}/${state.rowSelectItems[0].dlp_prf_id}/filters`)
      return resultFactory(commit, {length: null, data: data, action: 'getDlpFilterDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 필터데이터 추가
  async addDlpFilterDataAction ({commit, state}) {
    try {
      const data = await this.$axios.$post(`${state.txtDlpProfileUrl}/${state.rowSelectItems[0].dlp_prf_id}/filters`, state.modifyDlpFilterData)
      return resultFactory(commit, {length: null, data: data, action: 'addDlpFilterDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 필터데이터 수정
  async editDlpFilterDataAction ({commit, state}) {
    try {
      const data = await this.$axios.$put(`${state.txtDlpProfileUrl}/${state.filterRuleSelectItems[0].dlp_prf_id}/filters/${state.filterRuleSelectItems[0].dlp_filter_rule_id}`, state.modifyDlpFilterData)
      return resultFactory(commit, {length: null, data: data, action: 'editDlpFilterDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 필터 데이터 일괄 수정
  async editDlpFilterListDataAction ({commit, state, dispatch}, payload) {
    try {
      const data = await this.$axios.$put(`${state.txtDlpProfileUrl}/${state.filterRuleSelectItems[0].dlp_prf_id}/filters`, {items: payload}, {failAlert: false})
      return resultFactory(commit, {length: payload.length, data: data, action: null, param: 'edit'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 필터 데이터 삭제
  async delDlpFilterDataAction ({commit, state}) {
    let isMulty = false
    const idList = []
    if (state.filterRuleSelectItems.length > 1) {
      isMulty = true
      state.filterRuleSelectItems.forEach((item) => {
        idList.push({'dlp_prf_id': item.dlp_prf_id, 'dlp_filter_rule_id': item.dlp_filter_rule_id})
      })
    }
    try {
      const data = isMulty ? await this.$axios.$delete(`${state.txtDlpProfileUrl}/${state.rowSelectItems[0].dlp_prf_id}/filters`, {data: {items: idList}}, {failAlert: false})
        : await this.$axios.$delete(`${state.txtDlpProfileUrl}/${state.rowSelectItems[0].dlp_prf_id}/filters/${state.filterRuleSelectItems[0].dlp_filter_rule_id}`)
      return resultFactory(commit, {length: idList.length, data: data, action: null, param: 'delete'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 아카이브 데이터 조회
  async getDlpArchiveDataAction ({commit, state}) {
    try {
      const data = await this.$axios.$get(`${state.txtDlpProfileUrl}/${state.rowSelectItems[0].dlp_prf_id}/archives`)
      return resultFactory(commit, {length: null, data: data, action: 'getDlpArchiveDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 아카이브 데이터 추가
  async addDlpArchiveDataAction ({commit, state}) {
    try {
      const data = await this.$axios.$post(`${state.txtDlpProfileUrl}/${state.rowSelectItems[0].dlp_prf_id}/archives`, state.modifyDlpArchiveData)
      return resultFactory(commit, {length: null, data: data, action: 'addDlpArchiveDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 아카이브 데이터 수정
  async editDlpArchiveDataAction ({commit, state}) {
    try {
      const data = await this.$axios.$put(`${state.txtDlpProfileUrl}/${state.archiveRuleSelectItems[0].dlp_prf_id}/archives/${state.archiveRuleSelectItems[0].dlp_arch_rule_id}`, state.modifyDlpArchiveData)
      return resultFactory(commit, {length: null, data: data, action: 'editDlpArchiveDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 아카이브 데이터 일괄 수정
  async editDlpArchiveListDataAction ({commit, state, dispatch}, payload) {
    try {
      const data = await this.$axios.$put(`${state.txtDlpProfileUrl}/${state.archiveRuleSelectItems[0].dlp_prf_id}/archives`, {items: payload}, {failAlert: false})
      return resultFactory(commit, {length: payload.length, data: data, action: null, param: 'edit'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 아카이브 데이터 삭제
  async delDlpArchiveDataAction ({commit, state}) {
    let isMulty = false
    const idList = []
    if (state.archiveRuleSelectItems.length > 1) {
      isMulty = true
      state.archiveRuleSelectItems.forEach((item) => {
        idList.push({'dlp_prf_id': item.dlp_prf_id, 'dlp_arch_rule_id': item.dlp_arch_rule_id})
      })
    }
    try {
      const data = isMulty ? await this.$axios.$delete(`${state.txtDlpProfileUrl}/${state.rowSelectItems[0].dlp_prf_id}/archives`, {data: {items: idList}}, {failAlert: false})
        : await this.$axios.$delete(`${state.txtDlpProfileUrl}/${state.rowSelectItems[0].dlp_prf_id}/archives/${state.archiveRuleSelectItems[0].dlp_arch_rule_id}`)
      return resultFactory(commit, {length: idList.length, data: data, action: null, param: 'delete'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async commitAndRollBackPage ({commit, state}, type) {
    try {
      let msg = {}
      if (type === 'apply') {
        msg = {applyMsg: true}
      } else if (type === 'cancel') {
        msg = {cancelMsg: true}
      }
      const data = await this.$axios.$put(`${state.txtDlpProfileUrl}/${type}`, null, msg)
      if (data.code !== 'ok') {
        return false
      }
      this.dispatch(`common/common/setIsChanged`, false)
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  }
}
